import React from 'react'
import i18next from 'i18next'
import { Button, Form, Row, Col, Alert } from 'react-bootstrap'
import { Trans } from 'react-i18next'
import SelectBrandModal from '../../system_wide/select_brand_modal'
import { format, parseISO } from 'date-fns'
import hash from 'object-hash'
import DayPicker from '../../system_wide/day_picker'

const { t } = i18next

class DealerBrandsForm extends React.Component {
  static defaultProps = {
    dealer_brand: null,
    current_dealer_brands: [],
    brands: [],
    agent: null,
    readonly: false,
    onSave: () => {},
    closeForm: () => {},
  }

  state = {
    brand_id: null,
    brand: null,
    code: '',
    sig_fullname: '',
    sig_ssn: '',
    affiliation_date: null,
    relationship_end_date: null,
    contract_expires_date: null,
    contract_rejected_date: null,
    appointments_concluded_date: null,
    appointments_rejected_date: null,

    dealer_brand_hash: '',
  }

  initialHash = ''

  constructor(props) {
    super(props)
    if (props.dealer_brand) {
      let {
        brand_id,
        brand,
        code,
        sig_fullname,
        sig_ssn,
        affiliation_date,
        relationship_end_date,
        contract_expires_date,
        contract_rejected_date,
        appointments_creation_date,
        appointments_concluded_date,
        appointments_rejected_date,
      } = props.dealer_brand
      this.state.brand_id = brand_id
      this.state.brand = brand
      this.state.code = code
      this.state.sig_fullname = sig_fullname
      this.state.sig_ssn = sig_ssn
      this.state.affiliation_date = affiliation_date ? parseISO(affiliation_date) : null
      this.state.relationship_end_date = relationship_end_date ? parseISO(relationship_end_date) : null
      this.state.contract_expires_date = contract_expires_date ? parseISO(contract_expires_date) : null
      this.state.contract_rejected_date = contract_rejected_date ? parseISO(contract_rejected_date) : null
      this.state.appointments_concluded_date = appointments_concluded_date
        ? parseISO(appointments_concluded_date)
        : null
      this.state.appointments_rejected_date = appointments_rejected_date ? parseISO(appointments_rejected_date) : null
      this.state.appointments_creation_date = appointments_creation_date ? parseISO(appointments_creation_date) : null
    }

    let { dealer_brand_hash, ...rest } = this.state
    this.initialHash = hash(rest)
    this.state.dealer_brand_hash = this.initialHash
  }

  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { dealer_brand_hash, ...rest } = this.state

    this.setState({ dealer_brand_hash: hash(rest) })
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value }, () => this.updateHash())
  }

  isFormValid = () => {
    let { brand_id, affiliation_date, sig_fullname } = this.state

    return brand_id !== null && (!affiliation_date || sig_fullname) && (!sig_fullname || affiliation_date)
  }

  handleConfirm = () => {
    let dealer_brand = {
      brand_id: this.state.brand_id,
      brand: { name: this.props.brands.find(b => b.id === this.state.brand_id).name },
      code: this.state.code,
      sig_fullname: this.state.sig_fullname,
      sig_ssn: this.state.sig_ssn,
      affiliation_date: this.state.affiliation_date ? format(this.state.affiliation_date, 'yyyy-MM-dd') : '',
      relationship_end_date: this.state.relationship_end_date
        ? format(this.state.relationship_end_date, 'yyyy-MM-dd')
        : '',
      contract_expires_date: this.state.contract_expires_date
        ? format(this.state.contract_expires_date, 'yyyy-MM-dd')
        : '',
      contract_rejected_date: this.state.contract_rejected_date
        ? format(this.state.contract_rejected_date, 'yyyy-MM-dd')
        : '',
      appointments_concluded_date: this.state.appointments_concluded_date
        ? format(this.state.appointments_concluded_date, 'yyyy-MM-dd')
        : '',
      appointments_rejected_date: this.state.appointments_rejected_date
        ? format(this.state.appointments_rejected_date, 'yyyy-MM-dd')
        : '',
      appointments_creation_date: this.state.appointments_creation_date
        ? format(this.state.appointments_creation_date, 'yyyy-MM-dd')
        : '',
    }
    this.props.onSave(dealer_brand)
    this.props.closeForm()
  }

  handleChangeDate = name => target => {
    this.setState({ [name]: target.value }, () => this.updateHash())
  }
  handleChangeBrand = brand => {
    this.setState({ brand_id: parseInt(brand[0]) }, () => this.updateHash())
  }

  render() {
    let {
      brand_id,
      code,
      sig_fullname,
      sig_ssn,
      appointments_creation_date,
      appointments_concluded_date,
      appointments_rejected_date,
      affiliation_date,
      relationship_end_date,
      contract_expires_date,
      contract_rejected_date,
    } = this.state
    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="w-100 ps-1 pe-4 ">
            <Row>
              <Form.Group as={Col} md="6" sm="12" className="mt-3 mb-3">
                <SelectBrandModal
                  required={true}
                  disabled={this.props.readonly || this.props?.dealer_brand?.brand_id !== null}
                  selected={brand_id ? [brand_id] : []}
                  onChange={this.handleChangeBrand}
                  multiSelection={false}
                  readonly={this.props.readonly}
                  user_id={this.props?.agent?.id ?? null}
                  excludeBrands={this.props?.current_dealer_brands?.map(b => b.brand_id) ?? []}
                />
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3 align-content-center">
                <Form.Label>
                  <Trans i18nKey="components.dealer_brands_form.code">Codice</Trans>
                </Form.Label>
                <Form.Control
                  name="code"
                  placeholder={t('components.dealer_brands_form.code', 'Codice')}
                  value={code}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealer_brands_form.sig_fullname">Firmatario</Trans>
                </Form.Label>
                {affiliation_date && <span> *</span>}
                <Form.Control
                  name="sig_fullname"
                  type="text"
                  placeholder={t('components.dealer_brands_form.sig_fullname', 'Firmatario')}
                  value={sig_fullname}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealer_brands_form.sig_ssn">Codice Fiscale Firmatario</Trans>
                </Form.Label>
                <Form.Control
                  name="sig_ssn"
                  type="text"
                  placeholder={t('components.dealer_brands_form.sig_ssn', 'Codice Fiscale Firmatario')}
                  value={sig_ssn}
                  onChange={this.handleChange}
                  disabled={this.props.readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md={4} sm={12} className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealer_brands_form.affiliation_date">Data affiliazione</Trans>
                </Form.Label>
                {sig_fullname && <span> *</span>}
                <div style={{ width: '14rem' }}>
                  <DayPicker
                    value={affiliation_date}
                    onChange={this.handleChangeDate('affiliation_date')}
                    disabled={this.props.readonly}
                  />
                </div>
              </Form.Group>
              <Form.Group as={Col} md={4} sm={12} className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.dealer_brands_form.relationship_end_date">Data fine relazione</Trans>
                </Form.Label>
                <div style={{ width: '14rem' }}>
                  <DayPicker
                    value={relationship_end_date}
                    onChange={this.handleChangeDate('relationship_end_date')}
                    disabled={this.props.readonly}
                  />
                </div>
              </Form.Group>
              <Col sm={12} className="mb-3">
                <Alert variant="info">
                  <Alert.Heading>
                    <Trans i18nKey="components.dealer_brands_form.contract_other_info">
                      Altre informazioni relative al contratto
                    </Trans>
                  </Alert.Heading>
                  <div>
                    <Trans i18nKey="components.dealer_brands.contract_rejected_date">
                      Data rifiuto pratica contrattuale
                    </Trans>
                    : {(contract_rejected_date && format(contract_rejected_date, 'dd/MM/yyyy')) || '-'}
                  </div>

                  <div>
                    <Trans i18nKey="components.dealer_brands.contract_expires_date">
                      Data scadenza pratica contrattuale
                    </Trans>
                    : {(contract_expires_date && format(contract_expires_date, 'dd/MM/yyyy')) || '-'}
                  </div>
                  <Alert.Heading className="mt-3">
                    <Trans i18nKey="components.dealer_brands_form.appointments_info">
                      Informazioni relative alle visite
                    </Trans>
                  </Alert.Heading>
                  <div>
                    <Trans i18nKey="components.dealer_brands_form.appointments_creation_date">
                      Data creazione visita
                    </Trans>
                    : {(appointments_creation_date && format(appointments_creation_date, 'dd/MM/yyyy')) || '-'}
                  </div>
                  <div>
                    <Trans i18nKey="components.dealer_brands_form.appointments_concluded_date">
                      Data visita conclusa
                    </Trans>
                    : {(appointments_concluded_date && format(appointments_concluded_date, 'dd/MM/yyyy')) || '-'}
                  </div>
                  <div>
                    <Trans i18nKey="components.dealer_brands_form.appointments_rejected_date">
                      Data visita rifiutata
                    </Trans>
                    : {(appointments_rejected_date && format(appointments_rejected_date, 'dd/MM/yyyy')) || '-'}
                  </div>
                </Alert>
              </Col>
            </Row>
          </div>
        </div>
        <div className="border-top pt-2">
          {this.props.readonly === false && (
            <Button
              className="float-end"
              variant="primary"
              disabled={!this.isFormValid() || this.initialHash === this.state.dealer_brand_hash}
              onClick={this.handleConfirm}>
              <Trans i18nKey="buttons.confirm">Conferma</Trans>
            </Button>
          )}

          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
      </>
    )
  }
}

export default DealerBrandsForm
